import { atom } from 'recoil';

export const inviteCodeErrorState = atom<number>({
  key: 'inviteCodeErrorState',
  default: 0,
});
